import { type InputHTMLAttributes } from 'react'

import { ButtonText } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { type IconType } from '@/defs/icon'
import { extractInputProps, type InputProps } from '@/defs/input'
import { type DistributiveOmit } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import styles from './InputSearchbox.module.scss'

type BaseProps = {
  icon?: IconType
  onChange?: (value: string) => void
  onClear?: () => void
}

type Props = BaseProps &
  InputProps &
  DistributiveOmit<InputHTMLAttributes<HTMLInputElement>, keyof BaseProps | keyof InputProps | 'className'>

export const InputSearchbox = ({ icon = 'search', onChange, onClear, value, ...props }: Props) => {
  const isEmpty = !value
  const { inputProps, rest } = extractInputProps(props)

  return (
    <div className={cn(styles.container, { isEmpty, ...inputProps, styles })}>
      <div className={styles.field}>
        <input
          className={cn(styles.input, { isEmpty, styles })}
          onChange={(e) => onChange && onChange(e.currentTarget.value)}
          value={value || ''}
          {...rest}
        />
        <div className={cn(styles.icon, { size: 'lg', styles })}>
          {!value ? (
            <Icon name={icon} />
          ) : (
            <ButtonText aria-label='Clear' hover='warning' onClick={onClear}>
              <Icon name='xMark' />
            </ButtonText>
          )}
        </div>
      </div>
    </div>
  )
}
